import {Injectable} from '@angular/core';
import {ApiV2Service} from '../../../api-v2';
import {Observable} from 'rxjs';
import {ClusterRegion} from './cluster.region.vocabulary.model';

@Injectable({
  providedIn: 'root'
})
export class ClusterRegionsVocabularyService {
  private readonly RESOURCE_BASE = '/vocabulary/cluster/regions';

  constructor(
    private readonly api: ApiV2Service
  ) {
  }

  /**
   * Retrieves all cluster regions
   *
   * @returns Observable of cluster regions
   */
  public getAll(): Observable<ClusterRegion[]> {
    return this.api.get<ClusterRegion[]>(this.RESOURCE_BASE);
  }


}
